export const publisherJson = [
{
"publisher": "DEV",
"publisherImage": "https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
},
{
"publisher": "MEDIUM",
"publisherImage": "https://miro.medium.com/max/2000/1*jfdwtvU6V6g99q3G7gq7dQ.png"
},
{
"publisher": "IEEE",
"publisherImage":"https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Ieee_blue.jpg/800px-Ieee_blue.jpg"
},
];
